import { makeStyles } from '@mui/styles'
import { hexToRgba } from '../../../utils/commonUtils'

export default makeStyles((theme) => ({
    CommonLoaderBackdrop: {
        // @ts-expect-error TS(2339) FIXME: Property 'palette' does not exist on type 'Default... Remove this comment to see the full error message
        background: hexToRgba(theme.palette.lightGrey.main, 0.9),
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        zIndex: 9999999,
    },
    CommonLoaderBackdropContent: {
        maxWidth: '90%',
        maxHeight: '90%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        gap: '1.5rem',
    },
    CommonLoaderBackdropLoader: {},
    CommonLoaderBackdropMessage: {
        fontSize: '1.1rem',
        fontWeight: 900,
        width: '100%',
    },
}))
